// ============================================
// App Component
// ============================================

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SWRConfig } from 'swr';
import { AppLayout } from './components/layout/AppLayout';
import Dashboard from './pages/Dashboard';

// Lazy load other pages
import { lazy, Suspense } from 'react';
import { LoadingState } from './components/layout/LoadingState';

const ConstFunnel = lazy(() => import('./pages/ConstFunnel'));
const ConstMonthlyKPI = lazy(() => import('./pages/ConstMonthlyKPI'));
const EcomFunnel = lazy(() => import('./pages/EcomFunnel'));
const EcomMonthlyKPI = lazy(() => import('./pages/EcomMonthlyKPI'));
const MonthlyReport = lazy(() => import('./pages/MonthlyReport'));
const ConstMarch2026Report = lazy(() => import('./pages/ConstMarch2026Report'));
const EcomMarch2026Report = lazy(() => import('./pages/EcomMarch2026Report'));

function App() {
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        revalidateOnReconnect: true,
        dedupingInterval: 60000,
        errorRetryCount: 3,
        onError: (error, key) => {
          console.error(`SWR Error [${key}]:`, error);
        },
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AppLayout />}>
            <Route index element={<Dashboard />} />
            <Route
              path="const-funnel"
              element={
                <Suspense fallback={<LoadingState />}>
                  <ConstFunnel />
                </Suspense>
              }
            />
            <Route
              path="const-monthly-kpi"
              element={
                <Suspense fallback={<LoadingState />}>
                  <ConstMonthlyKPI />
                </Suspense>
              }
            />
            <Route
              path="ecom-funnel"
              element={
                <Suspense fallback={<LoadingState />}>
                  <EcomFunnel />
                </Suspense>
              }
            />
            <Route
              path="ecom-monthly-kpi"
              element={
                <Suspense fallback={<LoadingState />}>
                  <EcomMonthlyKPI />
                </Suspense>
              }
            />
            <Route
              path="monthly-report"
              element={
                <Suspense fallback={<LoadingState />}>
                  <MonthlyReport />
                </Suspense>
              }
            />
            <Route
              path="reports/const-march-2026"
              element={
                <Suspense fallback={<LoadingState />}>
                  <ConstMarch2026Report />
                </Suspense>
              }
            />
            <Route
              path="reports/ecom-march-2026"
              element={
                <Suspense fallback={<LoadingState />}>
                  <EcomMarch2026Report />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </SWRConfig>
  );
}

export default App;
